import axios from "axios";
import { proxyUrl } from "../config";
import { setupInterceptorsTo } from "./Interceptors";
setupInterceptorsTo(axios);

const DocumentIntelligenceService = {
    async sendDocumentToVerify(userId: number, data: any): Promise<any> {
        let url: string = `${proxyUrl}/userIdentities/${userId}/upload-documents`;

        const formData = new FormData();
        if (data.documentoAnverso) {
            formData.append('documentoAnverso', data.documentoAnverso);
        }
        if (data.documentoReverso) {
            formData.append('documentoReverso', data.documentoReverso);
        }

        try {
            const req = await axios.post(url, formData);
            return req.data;
        } catch (error: any) {
            if (error.response) {
                const backendMessage = error.response.data;
                return backendMessage;
            } else {
                return 'Error al enviar los documentos';
            }
        }
    },


     async sendDocumentToVerifyWithOrigenFondos(data: any): Promise<any> {
        console.log('sendDocumentToVerifyWithOrigenFondos >>> data: ', data);
        let url: string = `${proxyUrl}/userIdentities/origen-fondos`;

        const formData = new FormData();
        if (data.proofOfIncome) {
            formData.append('proofOfIncome', data.proofOfIncome);
        }
        console.log('sendDocumentToVerifyWithOrigenFondos >>> formData:', formData);

        try {
            const req = await axios.post(url, formData);
            return req.data;
        } catch (error: any) {
            if (error.response) {
                const backendMessage = error.response.data;
                return backendMessage;
            } else {
                return 'Error al enviar los documentos';
            }
        }
    },
};

export default DocumentIntelligenceService;